import { morphism } from 'morphism'
import { $TSFixMe } from 'types/ts-migrate'
import { currencyUtils } from '../../../utils'
import { getInvoiceTypesFromGroups } from './utils'
import {
  TAgencyPerformanceSummary,
  TSuspenseAccountStats,
  TSuspenseListQuery,
  TSuspenseListResponse,
  TSuspenseStatsFigure,
} from './types'

const { toCents } = currencyUtils

const agencyPerformanceSummarySchema = {
  bucketType: 'bucketType',
  buckets: ({ buckets }: $TSFixMe) => {
    return buckets.map((bucket: $TSFixMe) => ({
      ...bucket,
      invoiced: toCents(bucket?.invoiced || 0).getAmount(),
      collected: toCents(bucket?.collected || 0).getAmount(),
      commission: toCents(bucket?.commission || 0).getAmount(),
    }))
  },
}

export const transformAgencyPerformanceSummary = (source: $TSFixMe): TAgencyPerformanceSummary =>
  morphism(agencyPerformanceSummarySchema, source) as unknown as TAgencyPerformanceSummary

const accountsReceivableSchema = {
  agents: ({ agents }: $TSFixMe) => agents?.map(agent => agent.label) || [],
  owners: ({ owners }: $TSFixMe) => owners?.map(owner => owner.label) || [],
  invoiceTypes: ({ invoiceTypes }: $TSFixMe) => {
    return getInvoiceTypesFromGroups(invoiceTypes || [])
  },
}

export const transformAccountsReceivable = (source: $TSFixMe) => morphism(accountsReceivableSchema, source)

const tenancyScheduleSchema = {
  agents: ({ agents }: $TSFixMe) => agents?.map(agent => agent.label) || [],
  owners: ({ owners }: $TSFixMe) => owners?.map(owner => owner.label) || [],
  leaseStatuses: ({ leaseStatuses }: $TSFixMe) => leaseStatuses?.map((status: $TSFixMe) => status.label) || [],
  leaseTypes: ({ leaseTypes }: $TSFixMe) => leaseTypes?.map((type: $TSFixMe) => type.label) || [],
  includeDrafts: true,
}

export const transformTenancySchedule = (source: $TSFixMe) => morphism(tenancyScheduleSchema, source)

const timeframeReportSchema = {
  timeframe: ({ timeframe }: $TSFixMe) => ({
    start: timeframe?.start || null,
    finish: timeframe?.finish || null,
  }),
  filters: ({ filters }: $TSFixMe) => ({
    agents: filters?.agents?.map((agent: $TSFixMe) => agent.label) || [],
  }),
}

export const transformRentRoll = (source: $TSFixMe) => morphism(timeframeReportSchema, source)

export const transformDeposits = (source: $TSFixMe) => morphism(timeframeReportSchema, source)

/**
 * Suspense account. The API sends rands; the store holds cents.
 */
const toCentsFigure = ({ total, count }: TSuspenseStatsFigure): TSuspenseStatsFigure => ({
  total: toCents(total).getAmount(),
  count,
})

export const transformSuspenseAccountStats = (source: TSuspenseAccountStats): TSuspenseAccountStats => ({
  unallocated: toCentsFigure(source.unallocated),
  allocatedThisMonth: toCentsFigure(source.allocatedThisMonth),
  allocatedLastMonth: toCentsFigure(source.allocatedLastMonth),
})

export const transformSuspenseListResponse = (source: TSuspenseListResponse): TSuspenseListResponse => ({
  ...source,
  items: source.items.map(item => ({ ...item, amount: toCents(item.amount).getAmount() })),
})

/** The list endpoints take snake_case `page_size`, and an empty search is left off. */
export const transformSuspenseListQuery = ({ page, pageSize, sort, order, search }: TSuspenseListQuery) => ({
  page,
  page_size: pageSize,
  sort,
  order,
  ...(search ? { search } : {}),
})
